import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { useNuxtApp } from '#app'
import { useSyncData } from '@/composables/useSyncData'
import { useAuthStore } from '@/stores/useAuthStore'
import type { Integration } from '@/_api/models/integration'

export const useIntegrationStore = defineStore('integration', () => {
  const { $api, $grants } = useNuxtApp()
  const authStore = useAuthStore()

  const accountId = computed(() => authStore.activeGuid)

  const {
    items: integrations,
    count,
    hydrated,
    syncState,
    isSyncing,
    syncProgress,
    sync: _sync,
    findById,
  } = useSyncData<Integration>({
    service: $api.integration,
    key: 'integrations',
    accountId,
    grants: { integration: ['view'] },
  })

  const connect = ref<{ guid: string | null; query: any }>({
    guid: null,
    query: null,
  })

  const square = ref<{ device: any }>({
    device: null,
  })

  const sync = async (options?: { force?: boolean; change?: boolean }) => {
    if (!$grants.all({ integration: ['view'] })) {
      return
    }

    await _sync(options)
  }

  const syncDate = computed(() => syncState.value.date)

  const all = computed(() => integrations.value)

  const setConnectQuery = (query: any) => {
    connect.value.query = query
  }

  const setConnectGuid = (guid: string | null) => {
    connect.value.guid = guid
  }

  const setSquareDevice = (device: any) => {
    square.value.device = device
  }

  return {
    integrations,
    count,
    hydrated,
    syncState,
    isSyncing,
    syncProgress,
    syncDate,
    sync,
    findById,
    all,
    connect,
    square,
    setConnectQuery,
    setConnectGuid,
    setSquareDevice,
  }
})
